let searchInputs = [
    {
        id: 'deviceType',
        label: 'Device Type',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'make',
        label: 'Make',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'model',
        label: 'Model',
        type: 'text',
        placeholder: 'Model'
    },
    {
        id: 'incidentType',
        label: 'Incident Type',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'provider',
        label: 'Provider',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'optionType',
        label: 'Option Type',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'includeDisabled',
        label: 'Include Disabled',
        type: 'select',
        options: [

        ]
    }
]
export { searchInputs }